import { useNavigate } from "react-router-dom";
import Logo from '../../../asset/Logo.png'
export default function NavabarGest (){
    const navigate = useNavigate();
    return(
        <div className="flex lg:flex-row flex-col lg:gap-4">
            <div className="bg-[#5b90ab70] rounded-2xl flex lg:flex-col flex-row mb-5 p-2 lg:justify-left justify-center lg:w-1/3">
                <div>
                    <div className="flex flex-row items-center gap-4 justify-center">
                        <h1 className="lg:text-4xl font-bold text-xl text-white text-center">Gest-Lario</h1>
                        <img src={Logo} className="w-20"></img>
                    </div>
                </div>
            </div>
            <div className="bg-[#5b90ab70] rounded-2xl flex lg:flex-col flex-row mb-5 lg:p-2 p-4 lg:justify-left justify-center lg:w-2/3">
                    <div className="flex lg:flex-row flex-col gap-4 text-center justify-center lg:text-xl font-medium text-white  ">
                        <p className="cursor-pointer" onClick={()=> navigate("/ges_home")}>Home</p>
                        <p className="cursor-pointer" onClick={()=> navigate("/ges_clienti")}>Gestione clienti e dispositivi</p>
                        <p className="cursor-pointer" onClick={()=> navigate("/ins_interventi")}>Registra Intervento</p>
                        <p className="cursor-pointer" onClick={()=> navigate("/stor_interventi")}>Storico Interventi</p>
                        <p className="cursor-pointer" onClick={()=> navigate("/preventivi")}>Crea Preventivo</p>
                    </div>
            </div>
        </div>
    )
}